import { render, staticRenderFns } from "./dataPackageDetails.vue?vue&type=template&id=347daaed&scoped=true"
import script from "./dataPackageDetails.vue?vue&type=script&lang=js"
export * from "./dataPackageDetails.vue?vue&type=script&lang=js"
import style0 from "./dataPackageDetails.vue?vue&type=style&index=0&id=347daaed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347daaed",
  null
  
)

export default component.exports